module.exports = __webpack_public_path__ + "img/pdf_ambi.2ee838d6.png";